import { render, staticRenderFns } from "./IndexDivider.vue?vue&type=template&id=297e361d&scoped=true"
import script from "./IndexDivider.vue?vue&type=script&lang=js"
export * from "./IndexDivider.vue?vue&type=script&lang=js"
import style0 from "./IndexDivider.vue?vue&type=style&index=0&id=297e361d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297e361d",
  null
  
)

export default component.exports